function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#5DBAA0;}\n\t.st1{fill:#215282;}\n\t.st2{fill:#2780BA;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M60,186.7c-28.3-2.8-50.9-25.9-53-54.4c-2.3-32.5,21.7-59.8,52.8-63C38.4,81.9,24.4,105.9,26.3,133 C28,155.8,41.1,175.6,60,186.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M192.5,108.8c-0.4,0.6-0.8,1.1-1.2,1.7c-3.3,4.9-8.9,7.7-14.8,7.7h-1.1c-7.7,0-14.6-5-17.1-12.3 c-0.1-0.3-0.2-0.6-0.3-0.8c4.9-3.2,10.9-4.9,17.3-4.4C182,101.2,188,104.2,192.5,108.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M192.5,147.3c-5,5-11.9,8.2-19.5,8.2c-5.6,0-10.7-1.7-15-4.5c0.1-0.2,0.2-0.4,0.2-0.7 c2.6-7.4,9.3-12.4,17.1-12.4h1.1c5.9,0,11.5,2.9,14.9,7.8C191.7,146.2,192.1,146.7,192.5,147.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M192.5,147.3c-0.4-0.5-0.8-1.1-1.2-1.6c-3.3-4.9-8.9-7.8-14.9-7.8h-1.1c-7.8,0-14.6,5.1-17.1,12.4 c-0.1,0.2-0.2,0.4-0.2,0.7c-3.1-2-5.7-4.6-7.7-7.6c-2.9-4.3-7.7-6.8-12.9-6.8h-0.9c-6.8,0-12.7,4.4-14.9,10.8 c-8.4,24.3-32.3,41.4-59.8,39.5c-0.6,0-1.2-0.1-1.8-0.2c-18.8-11-32-30.9-33.6-53.7c-1.9-27.1,12-51.1,33.5-63.6c2-0.2,4-0.3,6-0.3 c25.9,0,47.8,16.6,55.8,39.8c2.2,6.4,8.1,10.7,14.8,10.7h0.9c5.1,0,10-2.5,12.9-6.7c2-3.1,4.7-5.7,7.7-7.7c0.1,0.3,0.2,0.6,0.3,0.8 c2.5,7.3,9.3,12.3,17.1,12.3h1.1c5.9,0,11.5-2.8,14.8-7.7c0.4-0.6,0.8-1.1,1.2-1.7c4.6,4.6,7.5,10.9,7.9,17.7 C200.8,134.6,197.8,142,192.5,147.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M158,105.1c-3.1,2-5.7,4.6-7.7,7.7c-2.9,4.3-7.7,6.7-12.9,6.7h-0.9c-6.7,0-12.6-4.3-14.8-10.7 C113.8,85.6,91.8,69,65.9,69c-2,0-4,0.1-6,0.3c10.1-5.9,21.7-9.2,34.2-9.2C123.5,60.1,148.6,78.9,158,105.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M158,150.9c-9.9,27.6-37.2,47-68.7,44.8c-10.6-0.7-20.6-3.9-29.4-9.1c0.6,0.1,1.2,0.1,1.8,0.2 c27.6,1.9,51.4-15.2,59.8-39.5c2.2-6.4,8.1-10.8,14.9-10.8h0.9c5.2,0,10,2.5,12.9,6.8C152.3,146.3,154.9,148.9,158,150.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M217.5,159.6c-10.2,0-19.2-4.8-25-12.3c5.2-5.3,8.3-12.7,7.9-20.8c-0.4-6.8-3.3-13.1-7.9-17.7 c6.3-8.1,16.4-13.2,27.6-12.2c15.6,1.2,28.1,14.1,28.9,29.7C250.1,144.5,235.6,159.6,217.5,159.6z"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.8ecaece5.svg";
export { ForwardRef as ReactComponent };